import React from "react";
import VideotronLogo from "./videotron-logo";

const Header = () => {
  return (
    <div className="vl-header">
      <VideotronLogo />
    </div>
  );
};

export default Header;
